import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

import { Image } from 'components/Image';
import { Text } from 'components/Text';
import { VideoAutoplay } from 'components/VideoAutoplay';
import { cx, capitalizeFirstLetter } from 'utility';
import * as styles from './Media.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
};

const defaultProps = {
    className: '',
    items: [],
};

function getClasses({ className, mediaSizeLayout }) {
    const classes = cx(
        className,
        styles['media'],
        styles[`media${capitalizeFirstLetter(mediaSizeLayout)}`],
    );

    return classes || undefined;
}

function getMediaSizeLayout(mediaItemLength) {
    if (mediaItemLength === 1) {
        return 'fullWidth';
    }
    else if (mediaItemLength === 2) {
        return 'halfWidth';
    }
    else {
        return 'overflowScroll';
    }
}

function Media({
    className,
    items,
}) {
    const mediaItemLength = items.length;
    const mediaSizeLayout = getMediaSizeLayout(mediaItemLength);
    const imageSize = (mediaSizeLayout === 'fullWidth') ? 'xlarge' : 'small';
    const classes = getClasses({ className, mediaSizeLayout });

    return (
        <div className={classes}>
            <div className={styles['grid']}>
                <div className={styles['container']}>
                    {items.map(({ media_caption, media_image, media_video_autoplay, media_video_upload }, index) => {
                        const caption = media_caption?.text;
                        const image = media_image;
                        const videoAutoplay = media_video_autoplay;
                        const videoUpload = media_video_upload?.url;

                        return (
                            <InView key={`media-item-${index}`} threshold={0.1} triggerOnce={true}>
                                {({ inView, ref, entry }) => {
                                    return (
                                        <figure className={cx(styles['figure'], (inView) && styles['inview'])} ref={ref}>
                                            {image?.url && (
                                                <div className={styles['mediaContainer']}>
                                                    <Image
                                                        className={styles['image']}
                                                        image={image}
                                                        size={imageSize}
                                                    />
                                                    {videoUpload && (
                                                        <VideoAutoplay
                                                            autoPlay={videoAutoplay}
                                                            className={styles['videoUpload']}
                                                            videoUploadUrl={videoUpload}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            {caption && (
                                                <Text
                                                    as="figcaption"
                                                    className={styles['caption']}
                                                    size={0}
                                                >
                                                    – {caption}
                                                </Text>
                                            )}
                                        </figure>
                                    );
                                }}
                            </InView>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

export { Media };
